// We expose a service which will be injectable into other controllers.
// This service is only a factory for the map controller.
app.factory('CartService', [
    '$controller', '$http', '$rootScope', '$modal',
    function($controller, $http, $rootScope, $modal) {

    return {
        /**
         * Return a new Cart controller
         *
         * @param $scope: The caller $scope
         */
        "get_cart": function($scope) {
            return $controller('CartCtrl', {
                $scope: $scope,
                $http: $http,
                $rootScope: $rootScope,
                $modal: $modal
            });
        },

        /**
         * Add a wallet operation to the cart
         *
         * @param UUID ticket_id: The ticket _id
         * @param Number amount: The amount
         * @param Number vat: VAT
         * @param function callback: Callback which receives the errors
         *                           (if any) and the server response (on success).
         */
        add_wallet_operation: function (ticket_id, amount, vat, callback) {
            var url  = '/carts/add_wallet_operation';
            if (PosConfig.session_id) {
                url += '?PHPSESSID=' + PosConfig.session_id;
            }

            var data = {
                ticket_id: ticket_id,
                amount: amount,
                vat: vat
            };

            var headers = {
                'Content-Type': 'application/json'
            };

            $http({
                'method': 'POST',
                'url': url,
                'data': data,
                'headers': headers
            })
            .success(function(rsp, status, headers, config) {
                callback && callback(null, rsp);
            })
            .error(function(rsp, status, headers, config) {
                callback && callback(rsp.flash ? rsp.flash.error : new Error());
            });
        },

        /**
         * Redeem a ticket article reward into the cart (hold until pay).
         *
         * @param UUID ticket_id
         * @param UUID article_id
         * @param UUID variant_id
         * @param Number|null article_idx
         * @param function callback
         */
        redeem_ticket_article: function (ticket_id, article_id, variant_id, article_idx, target_cart_item_index, callback) {
            if (typeof target_cart_item_index === 'function') {
                callback = target_cart_item_index;
                target_cart_item_index = null;
            }

            var url = '/carts/redeem_ticket_article';
            if (PosConfig.session_id) {
                url += '?PHPSESSID=' + PosConfig.session_id;
            }

            var data = {
                ticket_id: ticket_id,
                article_id: article_id,
                variant_id: variant_id
            };
            if (article_idx !== undefined && article_idx !== null) {
                data.article_idx = article_idx;
            }
            if (target_cart_item_index !== undefined && target_cart_item_index !== null) {
                data.target_cart_item_index = target_cart_item_index;
            }

            $http({
                method: 'POST',
                url: url,
                data: data,
                headers: { 'Content-Type': 'application/json' }
            })
            .success(function(rsp) {
                callback && callback(null, rsp);
            })
            .error(function(rsp) {
                var msg = null;
                if (rsp && rsp.error) {
                    msg = rsp.error;
                } else if (rsp && rsp.flash && rsp.flash.error) {
                    msg = rsp.flash.error;
                } else if (rsp && rsp.rsp && rsp.rsp.error) {
                    msg = rsp.rsp.error;
                } else if (rsp && rsp.rsp && rsp.rsp.flash && rsp.rsp.flash.error) {
                    msg = rsp.rsp.flash.error;
                }
                callback && callback(msg || new Error());
            });
        },

        /**
         * Add to the cart and pay a wallet operation
         *
         * @param UUID ticket_id: The ticket _id
         * @param Number amount: The amount
         * @param Number vat: VAT
         * @param function callback: Callback which receives the errors
         *                           (if any) and the server response (on success).
         */
        add_and_pay_wallet_operation: function (ticket_id, amount, vat, callback) {
            var operation = amount > 0 ? 'credit_wallet' : 'debit_wallet';
            var url  = '/tickets/' + operation + '/_id/' + ticket_id;
            if (PosConfig.session_id) {
                url += '?PHPSESSID=' + PosConfig.session_id;
            }

            var data = {
                amount: Math.abs(amount),
                vat: vat
            };

            var headers = {
                'Content-Type': 'application/json'
            };

            $http({
                'method': 'POST',
                'url': url,
                'data': data,
                'headers': headers
            })
            .success(function(rsp, status, headers, config) {
                callback && callback(null, rsp);
            })
            .error(function(rsp, status, headers, config) {
                callback && callback(rsp.flash ? rsp.flash.error : new Error());
            });
        },

        /**
         * Add to the cart an operation to use some como credit
         *
         * @param {String} phoneNumber: The como member phone number
         * @param {String} identificationCode: The como identification code to use
         * @param {Number} amount: The amount
         * @param {Number} vat: VAT
         * @param function callback: Callback which receives the errors
         *                           (if any) and the server response (on success).
         */
        add_como_debit_operation: function (phoneNumber, amount, vat, callback) {
            var url  = '/carts/add_como_debit_operation';
            if (PosConfig.session_id) {
                url += '?PHPSESSID=' + PosConfig.session_id;
            }

            var data = {
                phoneNumber: phoneNumber,
                amount: amount,
                vat: vat
            };

            var headers = {
                'Content-Type': 'application/json'
            };

            $http({
                'method': 'POST',
                'url': url,
                'data': data,
                'headers': headers
            })
            .success(function(rsp, status, headers, config) {
                callback && callback(null, rsp);
            })
            .error(function(rsp, status, headers, config) {
                callback && callback(rsp.flash ? rsp.flash.error : new Error());
            });
        },

        /**
         * Add to the cart an operation to use an asset
         *
         * @param {String} phoneNumber: The como member phone number
         * @param {Object} asset : an object with the following keys
         *                  - "key": "4UK...",
         *                  - "name": "Cadeau de bienvenue",
         *                  - "description": "10 CHF",
         *                  - "status": "Active",
         * @param Number vat: VAT
         * @param function callback: Callback which receives the errors
         *                           (if any) and the server response (on success).
         */
        add_como_asset_operation: function (phoneNumber, asset, vat, callback) {
            var url  = '/carts/add_como_asset_operation';
            if (PosConfig.session_id) {
                url += '?PHPSESSID=' + PosConfig.session_id;
            }

            var data = {
                phoneNumber: phoneNumber,
                asset: asset,
                vat: vat
            };

            var headers = {
                'Content-Type': 'application/json'
            };

            $http({
                'method': 'POST',
                'url': url,
                'data': data,
                'headers': headers
            })
            .success(function(rsp, status, headers, config) {
                callback && callback(null, rsp);
            })
            .error(function(rsp, status, headers, config) {
                callback && callback(rsp.flash ? rsp.flash.error : new Error());
            });
        },

        use_promo_code: function (code, callback) {
            var url = '/carts/use_promo_code';
            var cart = $rootScope.cart;
            if (cart && cart.uuid) {
                url += '/id/' + cart.uuid;
            }
            if (PosConfig.session_id) {
                url += (url.indexOf('?') >= 0 ? '&' : '?') +
                    'PHPSESSID=' + PosConfig.session_id;
            }

            $http({
                'method': 'POST',
                'url': url,
                'data': { code: code },
                'headers': { 'Content-Type': 'application/json' }
            })
            .success(function(rsp, status, headers, config) {
                callback && callback(null, rsp);
            })
            .error(function(rsp, status, headers, config) {
                callback && callback(rsp.flash ? rsp.flash.error : new Error());
            });
        },

        /**
         * Add to the cart an operation to use a promo code
         *
         * @param {String} phoneNumber: The como member phone number
         * @param {String} promoCode : the promo code to use
         * @param {Number} vat: VAT
         * @param function callback: Callback which receives the errors
         *                           (if any) and the server response (on success).
         */
        add_como_promo_code_operation: function (phoneNumber, promoCode, vat, callback) {
            var url  = '/carts/add_como_promo_code_operation';
            if (PosConfig.session_id) {
                url += '?PHPSESSID=' + PosConfig.session_id;
            }

            var data = {
                promoCode: promoCode,
                vat: vat
            };

            if (phoneNumber)
                data.phoneNumber = phoneNumber;

            var headers = {
                'Content-Type': 'application/json'
            };

            $http({
                'method': 'POST',
                'url': url,
                'data': data,
                'headers': headers
            })
            .success(function(rsp, status, headers, config) {
                callback && callback(null, rsp);
            })
            .error(function(rsp, status, headers, config) {
                callback && callback(rsp.flash ? rsp.flash.error : new Error());
            });
        },
    };
}]);
